import api from './api'

export const notaVentaService = {
  /**
   * Lista notas de venta con filtros opcionales.
   * @param {Object} filtros - { estado_pago, fecha_desde, fecha_hasta, busqueda }
   */
  listar(filtros = {}) {
    return api.get('/notas-venta', { params: filtros })
  },

  /**
   * Obtiene una nota de venta con sus detalles.
   * @param {number} id
   */
  obtener(id) {
    return api.get(`/notas-venta/${id}`)
  },

  /**
   * Crea una nota de venta. Incluye el cobro en el mismo paso (solo contado).
   * @param {Object} datos - { cliente_id, detalles[], cobro: { metodo_pago, destino_tipo, destino_id }, ... }
   */
  crear(datos) {
    return api.post('/notas-venta', datos)
  },

  /**
   * Anula una nota de venta: revierte inventario y el cobro registrado.
   * @param {number} id
   * @param {string|null} motivo
   */
  anular(id, motivo = null) {
    return api.post(`/notas-venta/${id}/anular`, { motivo })
  },

  /**
   * Obtiene el ticket HTML de la nota de venta.
   * @param {number} id
   */
  ticket(id) {
    return api.get(`/notas-venta/${id}/ticket`)
  }
}
